/* Manipiko · Página de producto landing (pago con tarjeta) */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '{{amount_with_comma_separator}} €';
    function fmt(n, dec, th, ds) {
      dec = isNaN(dec) ? 2 : dec;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(dec);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return whole + (parts[1] ? ds + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        default: return fmt(cents, 2, '.', ',');
      }
    });
  }

  function init(root) {
    if (!root || root.dataset.dlReady) return;
    root.dataset.dlReady = '1';
    var dataEl = root.querySelector('[data-dl-product]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var product = data.product;
    var form = root.querySelector('#dl-form');
    var idInput = root.querySelector('[data-dl-variant-id]');
    var qtyInput = root.querySelector('[data-dl-qty]');
    var errorEl = root.querySelector('[data-dl-error]');
    var toast = root.querySelector('[data-dl-toast]');
    var current = product.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || product.variants[0];

    /* ---------- Galería ---------- */
    var slider = root.querySelector('[data-dl-slider]');
    var slides = slider ? Array.prototype.slice.call(slider.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-dl-thumb]'));
    var counter = root.querySelector('[data-dl-counter]');
    var index = 0;
    function goTo(i, smooth) {
      if (!slider || !slides.length) return;
      i = (i + slides.length) % slides.length;
      slider.scrollTo({ left: slides[i].offsetLeft - slider.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActive(i);
    }
    function fitHeight() {
      if (!slider || !slides.length) return;
      var s = slides[index];
      if (s && s.offsetHeight) slider.style.height = s.offsetHeight + 'px';
    }
    function setActive(i) {
      index = i;
      fitHeight();
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      var th = thumbs[i];
      if (th && th.parentElement) {
        var box = th.parentElement;
        var left = th.offsetLeft - box.offsetLeft;
        if (left < box.scrollLeft || left + th.offsetWidth > box.scrollLeft + box.clientWidth) {
          box.scrollTo({ left: left - 16, behavior: 'smooth' });
        }
      }
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    if (slider) {
      slides.forEach(function (sl) {
        sl.querySelectorAll('img,video').forEach(function (m) {
          m.addEventListener('load', fitHeight); m.addEventListener('loadedmetadata', fitHeight);
        });
      });
      window.addEventListener('resize', fitHeight);
      window.addEventListener('load', fitHeight);
      setTimeout(fitHeight, 50);
      var t;
      slider.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(slider.scrollLeft / slider.clientWidth);
          if (i !== index) setActive(Math.max(0, Math.min(slides.length - 1, i)));
        }, 60);
      }, { passive: true });
      slider.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') goTo(index + 1);
        if (e.key === 'ArrowLeft') goTo(index - 1);
      });
    }
    thumbs.forEach(function (b) { b.addEventListener('click', function () { goTo(+b.dataset.dlThumb); }); });
    var prev = root.querySelector('[data-dl-prev]');
    var next = root.querySelector('[data-dl-next]');
    if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); });

    /* ---------- Variantes ---------- */
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-dl-option]'));
    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var sel = fs.querySelector('.dl-pill.is-selected');
        return sel ? sel.dataset.value : null;
      });
    }
    function setText(sel, txt) { root.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; }); }
    function toggle(sel, show) { root.querySelectorAll(sel).forEach(function (el) { el.hidden = !show; }); }

    function updateVariant(v) {
      if (!v) {
        root.querySelectorAll('[data-dl-buy], [data-dl-add]').forEach(function (b) { b.disabled = true; });
        setText('[data-dl-buy-label]', 'INDISPONIBLE');
        return;
      }
      current = v;
      idInput.value = v.id;
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      setText('[data-dl-price]', formatMoney(v.price, data.moneyFormat));
      setText('[data-dl-compare]', onSale ? formatMoney(v.compare_at_price, data.moneyFormat) : '');
      toggle('[data-dl-compare]', onSale);
      toggle('[data-dl-promo]', onSale);
      toggle('[data-dl-save]', onSale);
      toggle('[data-dl-pct]', onSale);
      if (onSale) {
        setText('[data-dl-save-amount]', formatMoney(v.compare_at_price - v.price, data.moneyFormat));
        setText('[data-dl-pct]', '-' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%');
      }
      root.querySelectorAll('[data-dl-buy], [data-dl-add]').forEach(function (b) { b.disabled = !v.available; });
      setText('[data-dl-buy-label]', v.available ? data.buyLabel : 'AGOTADO');
      if (v.featured_media) {
        var i = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(v.featured_media.id); });
        if (i > -1) goTo(i);
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('click', function (e) {
        var pill = e.target.closest('.dl-pill');
        if (!pill) return;
        fs.querySelectorAll('.dl-pill').forEach(function (p) {
          p.classList.toggle('is-selected', p === pill);
          p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
        });
        var lab = fs.querySelector('[data-dl-option-label]');
        if (lab) lab.textContent = pill.dataset.value;
        var opts = selectedOptions();
        var v = product.variants.find(function (variant) {
          return variant.options.every(function (o, n) { return opts[n] === null || o === opts[n]; });
        });
        updateVariant(v);
      });
    });

    /* ---------- Cantidad ---------- */
    function getQty() { if (!qtyInput) return 1; var q = parseInt(qtyInput.value, 10); return isNaN(q) || q < 1 ? 1 : Math.min(q, 99); }
    var minusBtn = root.querySelector('[data-dl-minus]'), plusBtn = root.querySelector('[data-dl-plus]');
    if (minusBtn) minusBtn.addEventListener('click', function () { qtyInput.value = Math.max(1, getQty() - 1); });
    if (plusBtn) plusBtn.addEventListener('click', function () { qtyInput.value = Math.min(99, getQty() + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = getQty(); });

    /* ---------- Carrusel de vídeos ---------- */
    var vtrack = root.querySelector('[data-dl-vtrack]');
    if (vtrack) {
      var step = function () { var it = vtrack.querySelector('.dl-vcar__item'); return it ? it.getBoundingClientRect().width + 14 : 260; };
      var vp = root.querySelector('[data-dl-vprev]'), vn = root.querySelector('[data-dl-vnext]');
      if (vp) vp.addEventListener('click', function () { vtrack.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (vn) vn.addEventListener('click', function () { vtrack.scrollBy({ left: step(), behavior: 'smooth' }); });
    }

    /* ---------- Pack Duo (1 / 2 unidades) ---------- */
    var bundles = root.querySelector('[data-dl-bundles]');
    var extraId = null;
    if (bundles && qtyInput) {
      var syncBundle = function () {
        var sel = bundles.querySelector('input:checked');
        if (!sel) return;
        qtyInput.value = sel.dataset.qty || sel.value;
        extraId = sel.dataset.extra ? parseInt(sel.dataset.extra, 10) : null;
        bundles.querySelectorAll('.dl-bundle').forEach(function (l) { l.classList.toggle('is-selected', l.contains(sel)); });
        root.querySelectorAll('.dl-sticky [data-dl-price]').forEach(function (el) { el.textContent = sel.dataset.total; });
        root.querySelectorAll('.dl-sticky [data-dl-compare]').forEach(function (el) { el.hidden = sel.value !== '1'; });
      };
      bundles.addEventListener('change', syncBundle);
      try {
        var want = new URLSearchParams(window.location.search).get('pack');
        var pre = want ? bundles.querySelector('input[value="' + want.replace(/[^a-z0-9]/gi, '') + '"]') : null;
        if (pre) pre.checked = true;
      } catch (e) {}
      syncBundle();
    }

    /* ---------- Carrusel de reseñas ---------- */
    var rtrack = root.querySelector('[data-dl-rtrack]');
    if (rtrack) {
      var rstep = function () { var it = rtrack.querySelector('.dl-rev__card'); return it ? it.getBoundingClientRect().width + 16 : 300; };
      var rp = root.querySelector('[data-dl-rprev]'), rn = root.querySelector('[data-dl-rnext]');
      if (rp) rp.addEventListener('click', function () { rtrack.scrollBy({ left: -rstep(), behavior: 'smooth' }); });
      if (rn) rn.addEventListener('click', function () { rtrack.scrollBy({ left: rstep(), behavior: 'smooth' }); });
    }

    /* ---------- Carrito / compra directa ---------- */
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }
    function showToast(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.hidden = false;
      clearTimeout(toast._t);
      toast._t = setTimeout(function () { toast.hidden = true; }, 3200);
    }
    function addToCart() {
      return fetch(data.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: current.id, quantity: getQty() }].concat(extraId ? [{ id: extraId, quantity: 1 }] : []).concat([].map.call(document.querySelectorAll('[data-mk-addon]:checked'), function (a) { return { id: parseInt(a.value, 10), quantity: parseInt(a.dataset.qty, 10) || 1 }; })) })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'No se ha podido añadir el producto.');
          return j;
        });
      });
    }
    function refreshCount() {
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) { root.querySelectorAll('[data-dl-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); })
        .catch(function () {});
    }

    /* ---------- Carrito lateral ---------- */
    var drawer = data.drawer ? root.querySelector('[data-mkd]') : null;
    var R = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/');
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
    function money(c) { return formatMoney(c, data.moneyFormat); }
    function dtitle(it) { var a = it.line_level_discount_allocations; if (a && a.length && a[0].discount_application) return a[0].discount_application.title; return it.discounts && it.discounts.length ? it.discounts[0].title : ''; }
    function renderCart(c) {
      if (!drawer) return;
      var box = drawer.querySelector('[data-mkd-items]');
      if (!c.items.length) { box.innerHTML = '<p class="mkd__empty">Tu carrito está vacío.</p>'; }
      else box.innerHTML = c.items.map(function (it) {
        var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160') + '" alt="" loading="lazy">' : '<span></span>';
        var orig = it.original_line_price, fin = it.final_line_price;
        var pr = '<span class="mkd__pr">' + (fin < orig ? '<s>' + money(orig) + '</s>' : '') + money(fin) + (fin < orig ? '<em>Ahorras ' + money(orig - fin) + '</em>' : '') + '</span>';
        return '<div class="mkd__it" data-key="' + esc(it.key) + '">' + img + '<div><b>' + esc(it.product_title) + '</b>' + (it.variant_title ? '<small class="mkd__vt">' + esc(it.variant_title) + '</small>' : '') + (dtitle(it) ? '<i class="mkd__tag">' + esc(dtitle(it)) + '</i>' : '') + '<span class="mkd__q"><button type="button" data-q="-1" aria-label="Quitar uno">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="Añadir uno">+</button></span></div>' + pr + '</div>';
      }).join('');
      drawer.querySelector('[data-mkd-total]').textContent = money(c.total_price);
      var save = drawer.querySelector('[data-mkd-save]');
      var disc = c.original_total_price - c.total_price;
      if (save) { save.hidden = !(disc > 0); save.textContent = disc > 0 ? '🎉 Estás ahorrando ' + money(disc) : ''; }
      var ups = drawer.querySelector('[data-mkd-ups]');
      if (ups) ups.hidden = c.items.some(function (it) { return String(it.product_id) === ups.dataset.pid; });
      root.querySelectorAll('[data-dl-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    }
    function loadCart() { return fetch(R + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; }); }
    function openDrawer() { if (!drawer) return; drawer.hidden = false; document.documentElement.style.overflow = 'hidden'; loadCart(); }
    function closeDrawer() { if (!drawer) return; drawer.hidden = true; document.documentElement.style.overflow = ''; }
    if (drawer) {
      drawer.querySelectorAll('[data-mkd-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });
      drawer.querySelector('[data-mkd-items]').addEventListener('click', function (e) {
        var b = e.target.closest('[data-q]'); if (!b) return;
        var row = b.closest('[data-key]'); var q = parseInt(row.querySelector('.mkd__q span').textContent, 10) + parseInt(b.dataset.q, 10);
        fetch(R + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: row.dataset.key, quantity: Math.max(0, q) }) })
          .then(function (r) { return r.json(); }).then(renderCart).then(function () { return loadCart(); }).catch(function () { loadCart(); });
      });
      var addUp = drawer.querySelector('[data-mkd-add]');
      if (addUp) addUp.addEventListener('click', function () {
        var ups = drawer.querySelector('[data-mkd-ups]'); addUp.disabled = true;
        fetch(data.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(ups.dataset.id, 10), quantity: 1 }] }) })
          .then(function () { return loadCart(); }).finally(function () { addUp.disabled = false; });
      });
    }

    root.querySelectorAll('[data-dl-buy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!current || !current.available) return;
        showError('');
        root.classList.add('is-loading');
        btn.disabled = true;
        addToCart()
          .then(function () {
            if (drawer) { root.classList.remove('is-loading'); btn.disabled = false; openDrawer(); return; }
            window.location.href = data.checkout;
          })
          .catch(function (err) {
            showError(err.message);
            root.classList.remove('is-loading');
            btn.disabled = false;
            var buy = document.getElementById('dl-buy');
            if (buy) buy.scrollIntoView({ behavior: 'smooth' });
          });
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!current || !current.available) return;
        showError('');
        var btn = form.querySelector('[data-dl-add]');
        if (btn) btn.disabled = true;
        addToCart()
          .then(function () { showToast('✓ Añadido al carrito'); refreshCount(); })
          .catch(function (err) { showError(err.message); })
          .finally(function () { if (btn) btn.disabled = !current.available; });
      });
    }

    /* ---------- Barra fija ---------- */
    var sticky = root.querySelector('[data-dl-sticky]');
    var mainBuy = form ? form.querySelector('[data-dl-buy]') : null;
    if (sticky && mainBuy && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var b = sticky.querySelector('button');
        if (b) b.tabIndex = show ? 0 : -1;
      });
      io.observe(mainBuy);
    }

    // Volver desde el checkout con el botón "atrás" del navegador
    window.addEventListener('pageshow', function () {
      root.classList.remove('is-loading');
      root.querySelectorAll('[data-dl-buy]').forEach(function (b) { b.disabled = !current.available; });
    });
  }

  function boot() { document.querySelectorAll('[data-dl-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-dl-root]')); });
})();
